import { handleConversationInitialization } from "~/modules/Conversation/ConversationErrorUtils";
import { ConversationsSdkImpl } from "~/modules/conversations/ConversationsSdkImpl";
import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { sendWorkerTrackingEvent } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { ConversationsUser } from "~/modules/conversations";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";




























export class GetConversationsUser implements Action<Promise<ConversationsUser>> {
    


    readonly #identity: string;

    constructor(identity: string) {
        this.#identity = identity;
    }

    async run(ctx: {}): Promise<ConversationsUser> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        const conversations = context.retrieveInstanceOf(ContextInstance.ConversationsSdkImpl, ConversationsSdkImpl);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        await taskRouter.init();
        const worker = taskRouter.worker;

        await handleConversationInitialization(conversations, {
            actionName: "GetConversationsUser",
            moduleName: "Conversation",
            worker,
            analytics,
            context,
            event: EVENTS.GetConversationsUserCompleted,
            extra: {},
            logger
        });

        try {
            const user = await conversations.getUser(this.#identity);
            sendWorkerTrackingEvent(EVENTS.GetConversationsUserCompleted, analytics, worker, {
                userSid: user.entityName
            });
            return user;
        } catch (error) {
            const errorMsg = `GetConversationsUser: Failed to get conversations user by the provided identity`;
            logger.error(errorMsg, error);
            sendWorkerTrackingEvent(EVENTS.GetConversationsUserCompleted, analytics, worker, { error: errorMsg });
            return throwFlexSdkError(context)(
                ErrorCode.FailedToRetrieveConversationsUser,
                { severity: ErrorSeverity.Error },
                errorMsg,
                error
            );
        }
    }
}
